import { render } from "./CreateRefundModal.vue?vue&type=template&id=12a8f630&ts=true"
import script from "./CreateRefundModal.vue?vue&type=script&lang=ts"
export * from "./CreateRefundModal.vue?vue&type=script&lang=ts"

import "./CreateRefundModal.vue?vue&type=style&index=0&id=12a8f630&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__